import { render } from "./itemslider.vue?vue&type=template&id=d2546956&scoped=true"
import script from "./itemslider.vue?vue&type=script&lang=js"
export * from "./itemslider.vue?vue&type=script&lang=js"

import "./itemslider.vue?vue&type=style&index=0&id=d2546956&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2546956"]])

export default __exports__